const AUTH_HEADER = import.meta.env.VITE_DYTE_AUTH_HEADER;
console.log("Auth header", AUTH_HEADER);

const config = {
  title: "string",
  preferred_region: "us-east-1",
  record_on_start: false,
  live_stream_on_start: false,
  recording_config: {
    max_seconds: 60,
    file_name_prefix: "string",
    video_config: {
      codec: "H264",
      width: 1280,
      height: 720,
      watermark: {
        url: "https://example.com",
        size: {
          width: 1,
          height: 1,
        },
        position: "left top",
      },
      export_file: true,
    },
    audio_config: {
      codec: "AAC",
      channel: "stereo",
      export_file: true,
    },
  },
  persist_chat: false,
  summarize_on_end: false,
};

export async function createMeeting(meetingName: string) {
  const url = "https://api.dyte.io/v2/meetings";

  config.title = meetingName;

  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: AUTH_HEADER,
    },
    body: JSON.stringify(config),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error(error);
    return { status: "error", message: error };
  }
}

export async function addParticipant(
  meetingId: string,
  participantId: string,
  participantName: string,
  preset: string
) {
  console.log("Adding participant to meeting", meetingId, participantId);
  const url = `https://api.dyte.io/v2/meetings/${meetingId}/participants`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: AUTH_HEADER,
    },
    body: JSON.stringify({
      name: participantName,
      preset_name: preset,
      custom_participant_id: participantId,
    }),
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return { status: "error", message: error };
  }
}
